import { styled } from '@mui/material/styles';

interface ButtonProps {
    active: boolean;
    focused: boolean;
}

export const StyledRemoveButton = styled('button')<ButtonProps>(({ active, focused }) => ({
    backgroundColor: active ? "#dc3545" : "transparent",
    border: "1px solid #dc3545",
    borderRadius: "4px",
    padding: "0",
    height: "24px",
    width: "24px",
    outline: focused ? "#000 none 0" : "initial"
})); 